module.exports = __webpack_public_path__ + "static/img/DjunaediHermawanto.52d1f8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/DjunaediHermawanto.png
// module id = 1Jn3
// module chunks = 36